module.exports = __webpack_public_path__ + "img/custom_size_img_en.3ffca2f6.png";